import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_arkhamasylum.png",
      alt: "Estratégias Arkham Asylum",
    },
    title: "Porque usar um robô?",

    // String ou array de strings
    text: "Um dos problemas que fazem vários traders perderem dinheiro é o emocional, não conseguir ser fiel a uma estratégia e muitas vezes tomar decisões erradas acabam prejudicando a assertividade e o lucro. Com o robô é diferente, ele segue a estratégia com precisão e não toma atitudes precipitadas, agindo de forma perfeita.",
    // testimonial: {
    //   text: "",
    //   author: {
    //     name: "",
    //     picture: "",
    //   },
    // },
  },

  strategies: {
    title: "Estratégias Arkham Asylum",
    heading: "Algoritmos avançados à sua disposição",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Arkham Asylum.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O Arkham Robô está no mercado desde 2019",
    col1: [
      "Desde o momento de sua fundação, a Arkham Robô sempre se concentrou em oferecer as melhores condições de negociação usando tecnologias inovadoras após muitos anos de experiência no setor financeiro.",
      "A Arkham Robô é uma empresa de desenvolvimento de software  que oferece 9 tipos de automação e mais 1.000  customizações. Temos muito orgulho da variedade de serviços que oferecemos aos nossos clientes e parceiros, sendo da mesma qualidade para todos independente da experiência e do valor investido.",
    ],
    col2: [
      // "Acreditamos que investir deve ser uma opção simples e acessível para todos. Oferecemos uma gama extensa de diferentes tipos de serviços, que se adequam ao que você busca no mercado financeiro.",
    ],
  },

  stats: {
    title: "Alguns números da Arkham Robô",
    subtitle:
      "Foi desenvolvida por especialistas levando em conta anos de testes.",
    data: [
      {
        value: "+3 anos",
        description: "Em atividade.",
      },
      {
        value: "+80k",
        description: "Operações realizadas com robô.",
      },
      {
        value: "27 estados",
        description: "Vários clientes de todos estados do brasil ",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da Arkham?",
    subtitle: "Veja quais as principais vantagens dos robôs da Arkham.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },

      ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "A Arkham Robô  sempre busca inovar e se adaptar com cenário do mercado financeiro, gerando segurança e assertividade nas operações realizadas.",
      author: "Leandro",
      job: "Analista",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Acredito q vcs estão sempre buscando o melhor pra todos",
      author: "Vanessa",
      job: "Administrador de empresa",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
